var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseModel from "./BaseModel";
import addressService from "@/services/address.service";
var AddressModel = /** @class */ (function (_super) {
    __extends(AddressModel, _super);
    function AddressModel(data) {
        var _this = _super.call(this, data) || this;
        _this.addressComponents = {
            locality: {},
            streetName: {},
            streetNumber: {},
            county: {},
            state: {},
            country: {},
            postalCode: {},
        };
        var hydrated = _super.prototype.useHydrator.call(_this, data);
        _this.addressComponents = (hydrated.addressComponents) ? addressService.convertAddressComponents(hydrated.addressComponents) : null;
        _this.aptNum = hydrated.aptNum;
        _this.base = hydrated.base;
        _this.crDate = hydrated.crDate;
        // disable from server
        _this.delivery = {
            isDeliverable: true
        };
        _this.formattedAddress = hydrated.formattedAddress;
        _this.id = hydrated.id;
        _this.lastUsedDate = hydrated.lastUsedDate;
        _this.latitude = hydrated.latitude;
        _this.longitude = hydrated.longitude;
        _this.name = hydrated.name;
        _this.note = hydrated.note;
        return _this;
    }
    AddressModel.prototype.hydrate = function (data) {
        var address = {};
        address.addressComponents = data.address_components || null;
        address.aptNum = data.apt_num || null;
        address.base = data.base || null;
        address.crDate = data.cr_date || null;
        address.formattedAddress = data.formatted_address || data.address || null;
        address.id = (data.hasOwnProperty("address_id")) ? data.address_id : null;
        address.lastUsedDate = (data.hasOwnProperty("last_used_date")) ? data.last_used_date : null;
        address.latitude = parseFloat(data.latitude) || null;
        address.longitude = parseFloat(data.longitude) || null;
        address.name = data.name || null;
        address.note = data.note || null;
        return address;
    };
    AddressModel.prototype.setDeliveryInformation = function (delivery_details) {
        this.delivery = {
            isDeliverable: delivery_details.is_deliverable,
            price: parseInt(delivery_details.price)
        };
    };
    return AddressModel;
}(BaseModel));
export var addressComponentMapper = {
    street_number: "streetNumber",
    route: "streetName",
    administrative_area_level_2: "county",
    locality: "locality",
    administrative_area_level_1: "state",
    country: "country",
    postal_code: "postalCode",
    subpremise: "aptNum"
};
export default AddressModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/AddressModel.ts
// module id = glSn
// module chunks = 18